import script from "./index.vue?vue&type=script&lang=jsx"
export * from "./index.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/design/components/atoms/data-table-column/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13e4e046"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13e4e046', __exports__)) {
    api.reload('13e4e046', __exports__)
  }
  
}


export default __exports__